import React from "react";
import { Link } from "react-router-dom";
import { ROUTES } from "../../../consts/routes";

const HIDE_LOGIN_BUTTON_FOR_URLS = [ROUTES.workspaces()];

class Header extends React.Component {
  render() {
    return (
      <div className="header">
        <div className="wrapper">
          <img src="/images/logo.png?v=123" alt="" />
          <div className="header-right">
            <ul className="nav">
              <li>
                <a href="https://www.aestheticrecord.com/">Home</a>
              </li>
              {!HIDE_LOGIN_BUTTON_FOR_URLS.includes(
                window.location.pathname,
              ) && (
                <li>
                  <Link to="/login" className="login">
                    Login
                  </Link>
                </li>
              )}
              <li>
                <a
                  href="https://www.aestheticrecord.com/Subscription-Pricing"
                  className="login"
                >
                  Get Started
                </a>
              </li>
            </ul>
          </div>
        </div>
      </div>
    );
  }
}

export default Header;
